import React from 'react';
import Chart from 'react-apexcharts';

const MiniScoreGraph = ({ data, color = '#3b82f6', height = 60, formatter }) => {
    if (!data || data.length === 0) return null;

    const values = data.map(d => d.value);
    const maxValue = Math.max(...values);
    const minValue = Math.min(...values);
    const padding = (maxValue - minValue) * 0.5; // Add dynamic padding based on range

    const chartOptions = {
        chart: {
            type: 'area',
            height: height,
            sparkline: {
                enabled: true
            }
        },
        grid: {
            padding: {
                top: 10,
                bottom: 10
            }
        },
        xaxis: {
            type: 'datetime',
            crosshairs: {
                width: 1
            }
        },
        yaxis: {
            show: false, // Ensure no labels
            max: maxValue + (padding || maxValue * 0.1), // Add padding to top
            min: Math.max(0, minValue - (padding || minValue * 0.1)) // Add padding to bottom, but not below 0
        },
        stroke: {
            curve: 'smooth',
            width: 2,
            colors: [color]
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.3,
                opacityTo: 0,
                stops: [0, 95, 100],
                colorStops: [
                    {
                        offset: 0,
                        color: color,
                        opacity: 0.3
                    },
                    {
                        offset: 95,
                        color: color,
                        opacity: 0
                    }
                ]
            }
        },
        tooltip: {
            fixed: {
                enabled: false
            },
            offsetX: 20,
            offsetY: 20,
            x: {
                show: true,
                format: 'dd MMM'
            },
            y: {
                title: {
                    formatter: function (seriesName) {
                        return ''
                    }
                },
                formatter: formatter || function (val) {
                    return val.toFixed(2)
                }
            },
            marker: {
                show: false
            }
        },
        markers: {
            size: 0,
            hover: {
                size: 5
            }
        },
        colors: [color]
    };

    const series = [{
        name: 'Price',
        data: data.map(point => ({ x: new Date(point.date).getTime(), y: point.value }))
    }];

    return (
        <div style={{ height: height, width: '100%' }}>
            <Chart options={chartOptions} series={series} type="area" height={height} width="100%" />
        </div>
    );
};

export default MiniScoreGraph;
